import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Svg = ({ className, ...props }) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  />
)

Svg.defaultProps = {
  className: '',
}

Svg.propTypes = {
  className: PropTypes.string,
}

export default styled(Svg)``
